"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var useStyles = (0, _core.makeStyles)({
  root: {
    fontSize: '12px',
    letterSpacing: '1.8px',
    color: '#333333',
    margin: '0 2px 0 2px',
    padding: '3px',
    '& .MuiButton-iconSizeMedium > *:first-child': {
      fontSize: '8px',
      color: '#333333'
    },
    '& .Mui-disabled *': {
      color: 'rgba(0, 0, 0, 0.26) !important'
    },
    '& .MuiButton-endIcon': {
      'margin-left': '9px'
    },
    '& .MuiButton-startIcon': {
      'margin-right': '11px'
    }
  },
  disabled: {
    '& *': {
      color: 'rgba(0, 0, 0, 0.26) !important'
    }
  }
});
var _default = useStyles;
exports["default"] = _default;